import { render, staticRenderFns } from "./SNSTemplate.vue?vue&type=template&id=07640992&scoped=true&"
import script from "./SNSTemplate.vue?vue&type=script&lang=js&"
export * from "./SNSTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SNSTemplate.vue?vue&type=style&index=0&id=07640992&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07640992",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
